import { ImpactIcon } from "./ImpactLevelIcon";
import { IEconomicCalendarDto } from "../api/economicCalendarApi";
import { formatDate } from "@/utils/dateTime";
import styles from "./EconomicCalendar.module.scss";

export const EconomicCalendarItem = ({ data }: { data: IEconomicCalendarDto }) => {
    const { event, impact, unit, actual, estimate, prev, time, icon } = data;
    const CDN_FLAG_URL = "https://flagcdn.com/";
    return (
        <div className={styles.item}>
            <div className={styles.label}>
                <div title={event} className={styles.title}>
                    {event}
                </div>
                <div className={styles.timestamp}>{formatDate(time, "h:mmA")}</div>
            </div>
            <div className={styles.metrics}>
                <img
                    src={`${CDN_FLAG_URL}${icon || "us"}.svg`}
                    height={24}
                    width={24}
                    className={styles.countryFlag}></img>
                <ImpactIcon level={impact} />
                <div className={styles.value}>{(actual && `${actual}${unit || ""}`) || "--"}</div>
                <div className={styles.value}>{(estimate && `${estimate}${unit || ""}`) || "--"}</div>
                <div className={styles.value}>{(prev && `${prev}${unit || ""}`) || "--"}</div>
            </div>
        </div>
    );
};
